import React, { PropsWithChildren, ReactNode } from "react";

interface Props {
  fallback: ReactNode;
  isLoading: boolean;
}

export const ComponentWithLoadingFallback: React.FC<
  PropsWithChildren<Props>
> = ({ children, fallback, isLoading }) => (
  <> {isLoading ? fallback : children} </>
);
